/**
 * Joining a meeting that is being recorded (row 718e501d PR 2).
 *
 * Founder 5979686265, killing break: "a guest is recorded before accepting the
 * recording notice". The server asks for agreement at the moment it matters:
 * while a recording is RUNNING, every join path (guest-auth, the guest
 * reconnect, a member's room token) answers 409 with
 * `{code: "recording_consent_required", notice_version, message}` until this
 * person has agreed. The join screen and the room turn that answer into the
 * notice and send the agreement back; nothing here decides on its own whether
 * a recording is running.
 */
import { RECORDING_CONSENT_VERSION } from "./recordingConsentNotice";

export const RECORDING_CONSENT_TO_JOIN_CODE = "recording_consent_required";

/** Where the guest's agreement is kept for the mid-meeting re-auths, the same
 *  way GUEST_ACCEPTED_NOTICE_KEY keeps the transcription acceptance. */
export const GUEST_ACCEPTED_RECORDING_KEY = "ftl_guest_accepted_recording_version";

export interface RecordingConsentToJoin {
  noticeVersion: string;
  message: string;
}

/** The server's "agree before you join" answer, or null for any other error. */
export function recordingConsentToJoin(err: unknown): RecordingConsentToJoin | null {
  const data = (err as { data?: unknown } | null)?.data as
    | { code?: unknown; notice_version?: unknown; message?: unknown }
    | undefined;
  if (!data || data.code !== RECORDING_CONSENT_TO_JOIN_CODE) return null;
  return {
    noticeVersion:
      typeof data.notice_version === "string" ? data.notice_version : RECORDING_CONSENT_VERSION,
    message:
      typeof data.message === "string" && data.message.trim()
        ? data.message
        : "This meeting is being recorded. To join, agree to be recorded.",
  };
}
